export default __webpack_public_path__ + "static/media/upload-svg.93917c5e.svg";